import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { red } from '@mui/material/colors';

interface QuarantineMessageProps {
  imageCount: number;
}

const QuarantineMessage: React.FC<QuarantineMessageProps> = ({ imageCount }) => {
  return (
    <Box className="quarantineMessage" sx={{ color: red[500], textAlign: 'left' }} data-testid="quarantine-message">
      <Typography variant="body1">
        Event Manager has already been completed for this Event. There are {imageCount} images that haven’t been sent to Prelab.
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: 'bold', mt: 2 }}>
        They will not be sent to the lab until this is resolved!
      </Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Please <Box component="span" sx={{ fontWeight: 'bold' }}>Report a Picture Day Issue</Box> in Field Service.
      </Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Provide any relevant details, including:
      </Typography>
      <ul style={{ paddingLeft: '20px', margin: '8px 0 0 0' }}>
        <li>
          <Typography variant="body1">
            If you changed Events in PDS after starting photography. If so include all <Box component="span" sx={{ fontWeight: 'bold' }}>Event Reference IDs (EVT/EVC)</Box>.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            If the <Box component="span" sx={{ fontWeight: 'bold' }}>Event Reference ID (EVT/EVC)</Box> of the Event shown in Field Service is different than what is displayed in PDS.
          </Typography>
        </li>
      </ul>
    </Box>
  );
};

export default QuarantineMessage;
